@if (isChannelModalVisible()) {
  <portal-context-modal-content
    [title]="title()"
    [pill]="pill()"
    [dataTracker]="'portal-context-channel-modal'"
    [autoCompleteOptions]="channelsOptions()"
    autoCompleteOptionLabel="label"
    (closeModal)="onCloseModal()"
    (selectAction)="selectAction($event)"
    (nextAction)="nextAction()"
    (previousAction)="previousAction()">
    <m-tab-view [tabPanelHeaders]="tabPanelHeaders">
      <ng-template [mTabIndex]="1" #tabContent>
        <div class="pt-2">
          <div class="flex flex-col pb-2">
            <div class="dp2 pb-2 text-gray-1000">Performance Overview</div>
            <p class="sh2 text-gray-1000">
              This is a summary of your tactic's recent activity. Use these
              insights to optimize its performance.
            </p>
          </div>
          <portal-context-summary
            [comparisonPeriod]="comparePeriod()"></portal-context-summary>
          <portal-context-channel-insights
            [viewBy]="viewByData().viewBy"></portal-context-channel-insights>
        </div>
      </ng-template>
      <ng-template [mTabIndex]="2" #tabContent>
        <div class="pt-2">
          <div class="flex pb-6 items-center">
            <span class="dp2 mr-4 text-gray-1000">Performance Metrics</span>
          </div>
          <portal-context-metrics></portal-context-metrics>
        </div>
      </ng-template>
      <ng-template [mTabIndex]="3" #tabContent>
        <div class="pt-2">
          <div class="flex pb-6 items-center">
            <span class="dp2 mr-4 text-gray-1000">Contributing Tactics</span>
          </div>
          <portal-context-media
            [isLoading]="isMediaLoading()"
            [table]="mediaTable()"
            [isDataAvailable]="isMediaDataAvailable()"
            [viewType]="'tactic'"></portal-context-media>
        </div>
      </ng-template>
    </m-tab-view>
  </portal-context-modal-content>
}
